import { z } from 'zod';
import { CreditPack, CreditReason } from '../enums.js';
import { IsoDateTimeSchema, UuidSchema } from '../primitives.js';

/**
 * Credit ledger entry. Append-only. Source of truth for credit balances.
 * `balanceAfter` is denormalized for fast reads but always validated against
 * the running sum during reconciliation.
 */
export const CreditLedgerEntrySchema = z.object({
  id: z.string(), // bigserial in Postgres; surfaced as string
  userId: UuidSchema,
  /** Positive for grants/purchases, negative for spends. */
  delta: z.number().int(),
  reason: CreditReason,
  refType: z.enum([
    'purchase',
    'approach_attempt',
    'subscription_period',
    'admin',
    'report_refund',
  ]),
  refId: z.string().nullable(),
  balanceAfter: z.number().int().min(0),
  createdAt: IsoDateTimeSchema,
});
export type CreditLedgerEntry = z.infer<typeof CreditLedgerEntrySchema>;

export const PurchaseRequestSchema = z.object({
  pack: CreditPack,
});
export type PurchaseRequest = z.infer<typeof PurchaseRequestSchema>;

/** Server response after Stripe Checkout session is created. */
export const CheckoutSessionResponseSchema = z.object({
  sessionId: z.string(),
  checkoutUrl: z.string().url(),
});
export type CheckoutSessionResponse = z.infer<typeof CheckoutSessionResponseSchema>;
